import Form from "../Form";
import Components from "../Components";

export default function (el) {
	var ruleRequired = function( inputName, message ) {
		return {
			'name': inputName,
			'rules': {
				stop: true,
				required: {
					message: message,
				}
			}
		};
	};
	var rules = [
		
		ruleRequired( 'nome-completo', 'O nome é obrigatório!' ),
		ruleRequired( 'telefone', 'O telefone é obrigatório!' ),
		(() => {
			let rule = ruleRequired( 'nascimento', 'A data de nascimento é obrigatória!' )
			rule.rules['valid-date'] = {
				start: (new Date).toJSON().replace(/T.*$/,'').split('-').reverse().join('/'),
				end: '01/01/1900',
				format: ( value ) => {
					return value.replace(/^(\d{2})\/(\d{2})\/(\d{4}).*/, '$3-$2-$1') + 'T12:00:00-0300'
				},
				message: 'a data de nascimento deve estar entre hoje e o ano de 1900!',
			};
			return rule
		})(),
		(() => {
			let rule = ruleRequired( 'cpf', 'O CPF é obrigatório' )
			rule.rules['cpf'] = {
				message: 'CPF digitado é inválido',
			};
			rule.rules['min'] = {
					min:14,
					message: 'CPF digitado incompleto',
				};
			return rule;
		})(),
		ruleRequired( 'endereco-completo', 'O endereço é obrigatório!' ),
		ruleRequired( 'numero', 'O numero é obrigatório!' ),
		ruleRequired( 'cep', 'O cep é obrigatório!' ),
		ruleRequired( 'bairro', 'O bairro é obrigatório!' ),
		ruleRequired( 'cidade', 'A cidade é obrigatória!' ),
		ruleRequired( 'estado', 'O estado é obrigatório!' ),
		{
			'name': 'email',
			'rules': { 
				stop: false,
				required: {
					message: 'E-mail é obrigatório!',
				},
				email: {
					message: 'E-mail inválido',
				}
			}
		},
		{
			'name': 'confirm-email',
			'rules': {
				stop: true,
				title: 'E-mail',
				equal: {
					value: '',
					field: 'Confirmaçao de e-mail',
					select: '[name="email"]',
					message: '{field} invalida!'
				}
			}
		},
		ruleRequired( 'password', 'A senha é obrigatória!' ),
		{
			'name': 'confirm-password',
			'rules': {
				stop: true,
				title: 'Senha',
				equal: {
					value: '',
					field: 'Confirmaçao de senha',
					select: '[name="password"]',
					message: '{field} invalida!'
				},
			}
		},
	];

	var getInputs = () => {
		var values = {};
		$(' input, select', el).each((event, element) => {
			if ($(element).attr('type') === "radio") {
				if(element.checked) {
					values[$(element).attr('name')] = $(element).val();
				}
			} else {
				values[$(element).attr('name')] = $(element).val();
			}
		});
		return values;
	};

	var registerEvents = () => {
		$('input[name="cep"]').mask('00000-000');
		$('input[name="cpf"]').mask('000.000.000-00');
		$('input[name="cnpj"]').mask('00.000.000/0000-00');
		$('input[name="telefone"]').mask('(00) 0000-00000');
		$('input[name="nascimento"]').mask('99/99/9999');
		new Form(el, rules, (form) => {
			Components.loading(el);
			$.ajax({
				method: "POST",
				url: wp.ajax_url,
				data: {
					action: 'sl_register',
					'data': getInputs(),
					'params': $(' [name="params"]', el).val()
				}
			}).done((response) => {
				if (typeof response.redirect != 'undefined') {
				   window.location = response.redirect;
				   return;
				}
				$(el).html(response);
				registerEvents();
				Components.loading(el, 'stop');
			});
		});
		Form.cep(el);
		changeCnpf();
	};

	let changeCnpf = () => {
		let radios = $('[name="pessoa"]', el);
		radios.on('change', e => {
			let r = $(e.currentTarget);
			if(r.val() === 'Pessoa Jurídica') {
				$('.cnpj-fields', el).show(); 
				rules.push((() => {
							let rule = ruleRequired( 'cnpj', 'CNPJ é obrigatório' );
							rule.rules['cnpj'] = {
								message: 'CNPJ digitado é inválido',
							};
							rule.rules['min'] = {
								min:17,
								message: 'CNPJ digitado incompleto',
							};
							return rule;
						})());

				rules.push(ruleRequired( 'razao-social', 'A razão social é obrigatória!' ));
				rules.push(ruleRequired( 'inscricao-estadual', 'A inscrição estadual é obrigatória!' ));
			} else {
				$('.cnpj-fields', el).hide();
				rules = rules.filter( e => {
					return [
						'cnpj',
						'razao-social',
						'inscricao-estadual',
					].indexOf(e.name) === -1;
				});
			}
		})
	}

	registerEvents();

	
}
